import styled, { css } from 'styled-components';
import { breakpointMap, theme } from '../../../theme';
import { BodyText } from '../../typography';
import { StyledContentCardProps } from './ContentCard';

const ContentCardBodyStylesSmall = css`
  line-height: 1.25rem;
`;

const ContentCardBodyStylesLarge = css`
  line-height: 1.5rem;
`;

const bodyStyles = {
  small: ContentCardBodyStylesSmall,
  large: ContentCardBodyStylesLarge,
};

export const ContentCardBody = styled(BodyText)<{
  cardSize: StyledContentCardProps['size'];
}>`
  text-align: center;
  padding-top: ${theme.spacings[1].rem};
  ${({ cardSize }) => breakpointMap(cardSize, (size) => bodyStyles[size])};
`;
